import {useEffect, useMemo, useRef} from 'react'
import {setCurrent} from '../../redux/actions/ui/dataImport/index.js'
import {updateForm, useAutoForm, dispatch, useSelector} from '../../store.js'
import {dataImportSelector} from './dataImportFunctions.js'
import {useZropdown} from '../../common/components/Zropdown.js'
import {filterOptions, tokenizeOptions} from '../../common/tokenizeOptions.js'
import {currentDropdownSelector} from '../../redux/selectors/ui/index.js'
import FilterDropdown from '../../common/components/FilterDropdown.js'
import {
  DefaultListItem,
  ItemSeparator,
  SelectButton,
} from '../../common/components/Zelect.js'

function filterFilterConfigs(dropdown, importOptions, optionTokens, text) {
  try {
    if (!text) {
      updateForm(dropdown, {
        results: importOptions,
        hasFoundNothing: false,
      })

      return
    }

    const results = filterOptions(text, optionTokens)

    updateForm(dropdown, {
      results,
      selectedIndex: 0,
      hasFoundNothing: results.length === 0,
    })
  } catch (err) {
    updateForm(dropdown, {
      serverError: err.message,
    })
  }
}

export default function DataImportFilter({importOptions}) {
  const dropdown = 'data_import_type'
  const current = useSelector(dataImportSelector).current
  const currentDropdown = useSelector(currentDropdownSelector)
  const optionTokens = useMemo(
    () => tokenizeOptions(importOptions),
    [importOptions],
  )
  const chosenOption = useMemo(
    () => importOptions.filter((option) => option.value === current)?.[0],
    [importOptions, current],
  )
  const form = useAutoForm(dropdown, {
    text: '',
    results: [],
    selectedIndex: 0,
    hasFoundNothing: false,
    serverError: null,
    hasChanged: false,
  })

  useEffect(() => {
    filterFilterConfigs(
      dropdown,
      importOptions,
      optionTokens,
      form && form.text,
    )
  }, [importOptions, form && form.text])

  const buttonRef = useRef()

  const {onChangeInternal, onSelectInternal, onConfirm, onUp, onDown} =
    useZropdown({
      dropdown,
      form,
      onSelect: (option) => {
        dispatch(setCurrent(option.value))

        updateForm(dropdown, {hasChanged: true})
      },
    })

  return (
    <div className="margin-bottom-20 flex flex--jc-center align-items-center">
      <strong className="margin-right-7">
        Type of data you want to import:
      </strong>
      <div
        className={`wrap-outer--tag-dropdown-with-filter lh-sm ${
          currentDropdown === dropdown ? 'open' : ''
        }`}
        data-dropdown={dropdown}
      >
        <SelectButton
          ref={buttonRef}
          dropdown={dropdown}
          chosenOptions={[chosenOption]}
        />
        <FilterDropdown
          dropdown={dropdown}
          form={form}
          onChangeInternal={onChangeInternal}
          onConfirm={onConfirm}
          onUp={onUp}
          onDown={onDown}
          placeholder="Search..."
          includeSearchInput
          parentRef={buttonRef}
        >
          <li className="list__item list__item--dropdown list__item--dropdown-header">
            <strong>Data Imports</strong>
          </li>
          {form.results.map((option, index) =>
            option.category ? (
              <DefaultListItem
                key={option.value}
                option={option}
                values={[current]}
                index={index}
                form={form}
                onSelectInternal={onSelectInternal}
              />
            ) : (
              <ItemSeparator
                key={option.value}
                option={option}
                isFocused={index === form.selectedIndex}
              />
            ),
          )}
          {form.hasFoundNothing && (
            <li className="list__item--dropdown list__item--dropdown-empty align-center">
              No option matches your search.
            </li>
          )}
        </FilterDropdown>
      </div>
    </div>
  )
}
